import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=212aae7d"
import script from "./credits.vue?vue&type=script&lang=js"
export * from "./credits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports